<script lang="ts">
  import type { Piece } from "../lib/stores/library.svelte.js";
  import { router } from "../lib/router.svelte.js";
  import { ui } from "../lib/stores/ui.svelte.js";
  import Cover from "./Cover.svelte";
  import Icon from "./Icon.svelte";

  let { piece, delay = 0 }: { piece: Piece; delay?: number } = $props();
</script>

<div class="card" style:animation-delay="{delay}ms">
  <a
    class="open cover-zoom"
    href="./noten/{piece.id}"
    onclick={(e) => (e.preventDefault(), router.go(`/noten/${piece.id}`))}
  >
    <Cover src={piece.thumb} alt="" transitionName="piece-{piece.id}" />
    <span class="text">
      <span class="title ellipsis">{piece.name}</span>
      <span class="artist t3 ellipsis"
        >{piece.artist || (piece.accessRole === "shared" ? `von ${piece.owner.displayName}` : "")}</span
      >
    </span>
  </a>
  <span class="fab" aria-hidden="true"><Icon name="play" size={20} /></span>
  <button
    type="button"
    class="more"
    aria-label="Aktionen für {piece.name}"
    onclick={() => (ui.actionsFor = piece.id)}
  >
    <Icon name="more" size={18} />
  </button>
  {#if piece.favorite}
    <span class="fav" aria-label="Favorit"><Icon name="starFill" size={18} /></span>
  {/if}
  {#if piece.accessRole === "shared"}
    <span class="shared" title="Geteilt von {piece.owner.displayName}"><Icon name="users" size={14} /></span>
  {/if}
</div>

<style>
  .card {
    position: relative;
    padding: 10px;
    border-radius: 14px;
    transition: background var(--dur-base);
    animation: rise var(--dur-sheet) var(--ease-out) both;
  }
  .card:hover {
    background: #1a1a1f;
  }
  .open {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }
  .title {
    font-weight: 800;
    font-size: 14px;
  }
  .artist {
    font-size: 12px;
    font-weight: 600;
    min-height: 1.3em;
  }
  .fab {
    position: absolute;
    right: 18px;
    bottom: 62px;
    width: 46px;
    height: 46px;
    border-radius: 50%;
    background: var(--accent);
    color: var(--on-accent);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.45);
    opacity: 0;
    transform: translateY(10px) scale(0.8);
    transition:
      opacity var(--dur-fast),
      transform var(--dur-base) var(--ease-pop);
    pointer-events: none;
  }
  .card:hover .fab {
    opacity: 1;
    transform: none;
  }
  .more {
    position: absolute;
    right: 16px;
    top: 16px;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: rgba(11, 11, 13, 0.65);
    color: var(--text);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity var(--dur-fast);
  }
  .card:hover .more,
  .more:focus-visible {
    opacity: 1;
  }
  @media (hover: none) {
    .more {
      opacity: 1;
    }
  }
  .fav {
    position: absolute;
    left: 18px;
    top: 18px;
    color: var(--accent-2);
    filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.5));
  }
  .shared {
    position: absolute;
    left: 18px;
    bottom: 62px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: rgba(11, 11, 13, 0.7);
    color: var(--text);
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
